import { AutomatedUnderwritingSystem, MortgageCategory } from "./constants";

export function getAutomatedUnderwritingSystem(mortgageCategory: MortgageCategory): AutomatedUnderwritingSystem {
    switch(mortgageCategory) {
        case MortgageCategory.CONSTRUCTION:
            return AutomatedUnderwritingSystem.LP;
        case MortgageCategory.FIXED_MORTAGE:
        case MortgageCategory.ARM:
        case MortgageCategory.FTHB: 
        case MortgageCategory.FTHB_ARM:
        case MortgageCategory.FHA:
        case MortgageCategory.REFINANCE:
        case MortgageCategory.VA:
        case MortgageCategory.LOT:
        case MortgageCategory.JUMBO:
            return AutomatedUnderwritingSystem.DU;
        case MortgageCategory.SECOND_MORTGAGE:
            return AutomatedUnderwritingSystem.ManualTraditional;
        case MortgageCategory.USDA:
            return AutomatedUnderwritingSystem.InvestorAus;
        default:
            return undefined;
    }
}